export default "__VITE_ASSET__BNT01bkP__"